import { getSessionToken, getTenant } from '@/stores/session'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    const token = getSessionToken()
    const tenant = getTenant()
    if (!token || !tenant) {
      throw redirect({ to: '/login' })
    }
    throw redirect({ to: '/quotes' })
  },
})
